import { Icon } from "@findemdev/maui";
import {
  AccessDeniedAction,
  AccessDeniedContent,
  AccessDeniedDescription,
  AccessDeniedIconFrame,
  AccessDeniedPage,
  AccessDeniedTitle,
} from "./RaasClientProjectPage.styled";

interface IRaasProjectAccessDeniedProps {
  actionLabel?: string;
  description?: string;
  onBackToProjects: () => void;
  title?: string;
}

export const RaasProjectAccessDenied = ({
  actionLabel = "Back to projects",
  description = "You don't have access to this project. Ask the owner or an admin to share it with you.",
  onBackToProjects,
  title = "Project access is restricted",
}: IRaasProjectAccessDeniedProps) => (
  <AccessDeniedPage>
    <AccessDeniedContent>
      <AccessDeniedIconFrame>
        <Icon icon="lock" $size={28} />
      </AccessDeniedIconFrame>
      <AccessDeniedTitle>{title}</AccessDeniedTitle>
      <AccessDeniedDescription>
        {description}
      </AccessDeniedDescription>
      <AccessDeniedAction onClick={onBackToProjects}>
        {actionLabel}
      </AccessDeniedAction>
    </AccessDeniedContent>
  </AccessDeniedPage>
);
